/* © NXAPP Limited */
import { Link } from 'react-router-dom'

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto space-y-6">
        <h1 className="text-2xl font-bold text-gray-900">Privacy Policy</h1>
        <p className="text-sm text-gray-500">Last updated: July 2026 · NXAPP Limited</p>
        <div className="prose prose-sm text-gray-700 space-y-4">
          <p>
            NXAPP Bulletin processes subscriber data on behalf of NXAPP Limited under UK GDPR.
            We collect email addresses and optional profile data (name, company, industry) to
            deliver the weekly newsletter.
          </p>
          <p>
            <strong>Lawful basis:</strong> Legitimate interest (B2B) or consent, depending on
            how a subscriber was added. Source is recorded per contact.
          </p>
          <p>
            <strong>Retention:</strong> Subscriber data is kept until unsubscribed or deleted on
            request. Suppressed contacts' emails are retained to prevent re-adding them.
          </p>
          <p>
            <strong>Your rights:</strong> Subscribers may request access, rectification, erasure,
            or a copy of their data by emailing <a href="mailto:privacy@nxapp.co.uk" className="text-brand-600">privacy@nxapp.co.uk</a>.
          </p>
          <p>
            <strong>Sub-processors:</strong> Supabase (database hosting), Resend (email delivery),
            Cloudflare (hosting), Anthropic (AI drafting — no subscriber data is sent to Anthropic).
          </p>
        </div>
        <Link to="/login" className="text-sm text-brand-600 hover:underline">← Back to login</Link>
      </div>
    </div>
  )
}
